import { NavLink } from 'react-router-dom';
import { Dropdown } from '../../../components/Dropdown/Dropdown';
import { ButtonLink } from '../../../components/Form/Button';
import { Icon, heart_filled } from '../../../components/Icon/Icon';
import { useTranslation } from '../../../i18n/i18n';
import { Res, useApi } from '../../../state/api';
import { useFavorites } from '../../../state/favorites';
import { useSession } from '../../../state/session';
import { ApiUser } from '../../../types';
import { CustomerTypeButton } from '../CustomerTypeSwitch/CustomerTypeSwitch';
import './NavigationDropdown.css';

type NavigationDropdownProps = {};

export function NavigationDropdown({}: NavigationDropdownProps): JSX.Element {
	const urls = useTranslation().routes;
	const t = useTranslation().navigation;
	const myPages = useTranslation().myPagesNavigation;
	const routes = useTranslation().routes;
	const { isLoggedIn } = useSession();
	const { favorites } = useFavorites();
	const { user } = useSession();
	const { data: bonusData } = useApi(Res.session, {});

	function topText(apiData: boolean | ApiUser | undefined): string {
		let text = t.myPages;
		if (typeof apiData === 'object' && apiData.firstname.length !== 0 && apiData.firstname.length <= 16) {
			text = apiData.firstname;
		}
		return text;
	}

	const notLoggedInItems = [
		<ButtonLink className="big" linkTo={routes.login}>
			{t.login}
		</ButtonLink>,
		<NavLink className="button navigation-item register-account" to={urls.createAccount}>
			{t.createAccount}
		</NavLink>,
	];

	const loggedInItems = [
		/* the section the rest of these live in, named the way the menu along its own top names it */
		<NavLink exact className="button navigation-item" to={urls.myPages}>
			{myPages.myPages}
		</NavLink>,
		<NavLink className="button navigation-item" to={urls.yourOrders}>
			{t.myOrders}
		</NavLink>,
		<NavLink className="button navigation-item" to={urls.bonus}>
			{t.myBonus}
		</NavLink>,
		<NavLink to={urls.favorites}>
			<div className="favorites-row">
				{t.favorites}
				<div className="favorites-column">
					<Icon shape={heart_filled} className="favorites-icon-dropdown" />
					<span className="favorites-item-count">{favorites?.length}</span>
				</div>
			</div>
		</NavLink>,
		<NavLink className="button navigation-item" to={urls.previouslyBought}>
			{t.purchasedItems}
		</NavLink>,
		user?.specials ? (
			<NavLink className="button navigation-item" to={urls.specialPrices2}>
				{t.specialPrices}
			</NavLink>
		) : (
			<></>
		),
		/*
		 * No On Repeat here. The page is reached by url and by the my-pages menu while on it, and
		 * stays unannounced until it has been tried out properly.
		 */
		// user?.specials ? (
		// 	<NavLink className="button navigation-item" to={urls.exportStatistics}>
		// 		{t.exportStatistics}
		// 	</NavLink>
		// ) : (
		// 	<></>
		// ),
		user?.master ? (
			<NavLink className="button navigation-item" to={urls.switchAccount}>
				{t.switchAccount}
			</NavLink>
		) : (
			<></>
		),
		<NavLink className="button navigation-item" to={urls.account}>
			{t.settings}
		</NavLink>,
		<hr style={{ margin: '0' }} />,
	];

	return (
		<Dropdown label={topText(bonusData)} items={isLoggedIn ? loggedInItems : notLoggedInItems}>
			<CustomerTypeButton />
		</Dropdown>
	);
}
